// Constant parameters

// IG Story
export const IG_1k5k_STORY_CPM = 20;
export const IG_5k25k_STORY_CPM = 15;
export const IG_25k75k_STORY_CPM = 12;
export const IG_75k250k_STORY_CPM = 10;
export const IG_250k1m_STORY_CPM = 10;
export const IG_1mPlus_STORY_CPM = 8;

// IG InFeed
export const IG_1k5k_INFEED_CPM = 40;
export const IG_5k25k_INFEED_CPM = 30;
export const IG_25k75k_INFEED_CPM = 24;
export const IG_75k250k_INFEED_CPM = 20;
export const IG_250k1m_INFEED_CPM = 20;
export const IG_1mPlus_INFEED_CPM = 16;

// IG Reels
export const IG_1k5k_REELS_CPM = 40;
export const IG_5k25k_REELS_CPM = 30;
export const IG_25k75k_REELS_CPM = 24;
export const IG_75k250k_REELS_CPM = 20;
export const IG_250k1m_REELS_CPM = 20;
export const IG_1mPlus_REELS_CPM = 16;

// TT Story
export const TT_1k25k_STORY_CPM = 13;
export const TT_25k100k_STORY_CPM = 10;
export const TT_100k500k_STORY_CPM = 8;
export const TT_500k1m_STORY_CPM = 8;
export const TT_1mPlus_STORY_CPM = 7;

// TT Video
export const TT_1k25k_VIDEO_CPM = 22;
export const TT_25k100k_VIDEO_CPM = 20;
export const TT_100k500k_VIDEO_CPM = 16;
export const TT_500k1m_VIDEO_CPM = 16;
export const TT_1mPlus_VIDEO_CPM = 14;


/*
FROM GOOGLE SPREADSHEET COPY column J from calculator constants sheet
*/

// Hourly rates
export const IG_1k5k_RATE = 25;
export const IG_5k25k_RATE = 50;
export const IG_25k75k_RATE = 100;
export const IG_75k250k_RATE = 200;
export const IG_250k1m_RATE = 250;
export const IG_1mPlus_RATE = 500;
export const TT_1k25k_RATE = 25;
export const TT_25k100k_RATE = 100;
export const TT_100k500k_RATE = 200;
export const TT_500k1m_RATE = 250;
export const TT_1mPlus_RATE = 500;
// Multipliers
export const IG_INFEED_ER_1p5_MULT = 0;
export const IG_INFEED_ER_2p5_MULT = 0.025;
export const IG_INFEED_ER_4_MULT = 0.05;
export const IG_INFEED_ER_4plus_MULT = 0.1;
export const IG_STORY_VR_5_MULT = 0;
export const IG_STORY_VR_10_MULT = 0.05;
export const IG_STORY_VR_15_MULT = 0.1;
export const IG_STORY_VR_15plus_MULT = 0.15;
export const TT_VIDEO_VR_5_MULT = 0;
export const TT_VIDEO_VR_10_MULT = 0.05;
export const TT_VIDEO_VR_15_MULT = 0.1;
export const TT_VIDEO_VR_15plus_MULT = 0.15;
export const TT_STORY_VR_5_MULT = 0;
export const TT_STORY_VR_10_MULT = 0.05;
export const TT_STORY_VR_15_MULT = 0.1;
export const TT_STORY_VR_15plus_MULT = 0.15;
export const EVENT_MULT = 0;  // ??
export const ORGANIC_CONTENT_MULT = 0.025;
export const PAID_SOCIAL_MULT = 0.05;
export const DIGITAL_MEDIA_MULT = 0.075;
export const OOH_MULT = 0.1;
export const BROADCAST_MULT = 0.2;
export const FULLIP_MULT = 0.25;
export const EXCLUSIVITY_MINOR_MULT = 0.1;
export const EXCLUSIVITY_NONCORE_MULT = 0.15;
export const EXCLUSIVITY_CORE_MULT = 0.25;
export const INDUSTRY_REGULAR_MULT = 0;
export const INDUSTRY_TECH_MULT = 0.1;
export const INDUSTRY_AUTO_MULT = 0.1;
export const INDUSTRY_INSURANCE_MULT = 0.15;
export const INDUSTRY_FINANCE_MULT = 0.15;
export const INDUSTRY_GOVERNMENT_MULT = 0.2;
export const BUSY_MULT = 0.05;
export const QUICK_MULT = 0.05;
export const GIVEAWAY_MULT = 0.05;
export const PRO_MULT = 0.2;
export const QUALITY_MULT = 0.25;
export const OPTIN_DISCOUNT = 0.5;  // ??
// Content multipliers
export const ORGANICSOCIAL_CONTMULT = 0.05;  // not used in app
export const ORGANICSITE_CONTMULT = 0.05;
export const PAIDSOCIAL_CONTMULT = 0.1;
export const DIGITALMEDIA_CONTMULT = 0.15;
export const OOH_CONTMULT = 0.2;
export const BROADCAST_CONTMULT = 0.2;  // not used in app
export const FULLIP_CONTMULT = 0.25;
export const CONTOPTIN_DISCOUNT = 0.5;  // ??
// Content baselines
export const CONTBASE_IMG_PRO_10k = 50;
export const CONTBASE_IMG_PRO_100k = 100;
export const CONTBASE_IMG_PRO_500k = 200;
export const CONTBASE_IMG_PRO_500kplus = 500;
export const CONTBASE_IMG_REG_10k = 25;
export const CONTBASE_IMG_REG_100k = 50;
export const CONTBASE_IMG_REG_500k = 100;
export const CONTBASE_IMG_REG_500kplus = 250;
export const CONTBASE_VIDEO_PRO_10k = 100;
export const CONTBASE_VIDEO_PRO_100k = 200;
export const CONTBASE_VIDEO_PRO_500k = 400;
export const CONTBASE_VIDEO_PRO_500kplus = 1000;
export const CONTBASE_VIDEO_REG_10k = 50;
export const CONTBASE_VIDEO_REG_100k = 100;
export const CONTBASE_VIDEO_REG_500k = 200;
export const CONTBASE_VIDEO_REG_500kplus = 500;

























































































































































































































































































































































































































































































































































































































































































































































































































































































































































